import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { __ } from '../../../../helpers/translations';
import UploadReviewParticipantListModal from '../modals/UploadReviewParticipantListModal';

function UploadReviewParticipantsButton({ reviewId, onChanged, demo }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        title={__('G270')}
        size={demo ? 'sm' : 'md'}
        variant="light"
        disabled={demo}
        onClick={() => setShowModal(true)}
      >
        <FontAwesomeIcon icon={faUsers} />
      </Button>
      {showModal && (
      <UploadReviewParticipantListModal
        reviewId={reviewId}
        onCancel={() => setShowModal(false)}
        onChanged={async () => {
          await onChanged();
          setShowModal(false);
        }}
      />
      )}
    </>

  );
}

UploadReviewParticipantsButton.propTypes = {
  reviewId: PropTypes.string.isRequired,
  onChanged: PropTypes.func,
  demo: PropTypes.bool,
};

export default UploadReviewParticipantsButton;
